var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"480px"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-card',[_c('v-card-text',{staticClass:"pt-8"},[_c('h3',{staticClass:"py-2",attrs:{"align":"center"}},[_vm._v(" ຕ້ອງການລຶບຂໍ້ມູນນີ້ບໍ່ ? ")]),_vm._t("default",null,null,{ close: _vm.close })],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }